import AuthenticationBase from './AuthenticationBase'

export default class AuthenticationService extends AuthenticationBase {
  signInUser(params) {
    const options = {
      method: 'POST',
      body: params,
    }

    if (params.redirectObject) {
      return this.absoluteFetch(
        `/user/login?redirect_${params.redirectObject.type}=${params.redirectObject.value}`,
        options
      )
    }

    return this.absoluteFetch('/user/login', options)
  }

  signOutUser(params) {
    const options = {
      method: 'DELETE',
    }
    return this.absoluteFetch('/user/logout', options)
  }

  createUser(params) {
    const options = {
      method: 'POST',
      body: params,
    }

    if (params.redirectObject) {
      return this.absoluteFetch(
        `/user/signup?redirect_${params.redirectObject.type}=${params.redirectObject.value}`,
        options
      )
    }
    return this.absoluteFetch('/user/signup', options)
  }

  requestResetPassword(params) {
    const options = {
      method: 'POST',
      body: params,
    }
    return this.fetch('/user/reset-password', options)
  }

  resetPassword(token, params) {
    const options = {
      method: 'PATCH',
      body: params,
    }
    return this.fetch(`/user/reset-password/${token}`, options)
  }

  requestConfirmationEmail() {
    const options = {
      method: 'POST',
    }
    return this.fetch('/user/confirmation', options)
  }

  changeEmail(params) {
    const options = {
      method: 'PATCH',
      body: params,
    }
    return this.fetch('/user/update_email', options)
  }

  confirmEmail(token) {
    const options = {
      method: 'PATCH',
    }
    return this.fetch(`/user/confirmation/${token}`, options)
  }
}

if (process.env.NODE_ENV === 'development') {
  window.api = AuthenticationService
}
